import type { MocoSyncResult } from "@ca/types/moco";

const mocoSyncMessage = (result: MocoSyncResult): string => {
	switch (result.outcome) {
		case "accepted":
			return "Synced to Moco";
		case "stale":
			return "Moco already has a newer version";
		case "invalid":
			return `Moco rejected the snapshot: ${result.errors.join("; ")}`;
		case "error":
			return ["Moco couldn't store the snapshot", ...result.errors].join(": ");
		case "failed":
			return `Couldn't sync to Moco: ${result.error}`;
	}
};

export const mocoSyncOutcome = (resp: { data: unknown; error: unknown; status: number }): string => {
	const results = resp.status === 200 ? (resp.data as undefined | { results?: MocoSyncResult[] })?.results ?? [] : [];
	const result = results.find((row) => row.outcome !== "accepted" && row.outcome !== "stale") ?? results[0];
	if (!result) {
		throw new Error((resp.error as { value?: { message?: string } })?.value?.message ?? "Failed to sync to Moco");
	}
	const message = mocoSyncMessage(result);
	if (result.outcome !== "accepted" && result.outcome !== "stale") throw new Error(message);
	return message;
};
